import { Link } from "react-router-dom";

export default function PrivacyPolicy() {
  return (
    <article data-testid="privacy-policy-page" className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 font-ui text-[#1A362D] leading-relaxed">
      <p className="label-eyebrow text-[#C05C45]">Informativa</p>
      <h1 className="mt-2 font-display text-4xl sm:text-5xl tracking-tight">Privacy Policy</h1>
      <p className="mt-6 text-[#5C6B64]">
        Ultimo aggiornamento: {new Date().toLocaleDateString("it-IT", { year: "numeric", month: "long" })}
      </p>

      <section className="mt-10 space-y-4">
        <h2 className="font-display text-2xl mt-8">1. Titolare del trattamento</h2>
        <p>
          Il sito <strong>"Per manina"</strong> (accessibile all'indirizzo{" "}
          <em>permanina.it</em>) è gestito da <strong>Luca Jacchia</strong>, con sede operativa in Italia.
          Per qualsiasi richiesta relativa al trattamento dei tuoi dati puoi scrivere all'indirizzo{" "}
          <a href="mailto:info@permanina.it" className="text-[#C05C45] underline">info@permanina.it</a>.
        </p>

        <h2 className="font-display text-2xl mt-8">2. Principi generali</h2>
        <p>
          Trattiamo i tuoi dati nel rispetto del Regolamento UE 2016/679 (GDPR), seguendo i principi di{" "}
          <strong>minimizzazione</strong>, <strong>trasparenza</strong> e <strong>limitazione delle finalità</strong>.
          La navigazione del sito è possibile <strong>in modalità ospite</strong>, senza registrazione.
        </p>

        <h2 className="font-display text-2xl mt-8">3. Dati raccolti (solo a registrazione avvenuta)</h2>
        <p>Quando scegli di registrarti tramite Google Login raccogliamo esclusivamente:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li><strong>Indirizzo email</strong> e <strong>nome pubblico</strong> forniti dal tuo account Google.</li>
          <li><strong>Immagine profilo</strong> di Google (visualizzata accanto alle tue esperienze).</li>
          <li><strong>Contenuto delle esperienze</strong> che pubblichi volontariamente (recensioni di scuole, prodotti, risposte).</li>
          <li><strong>Consenso al marketing</strong> (facoltativo, opt-in): se lo attivi, registriamo email, nome e data del consenso per inviarti la newsletter editoriale.</li>
        </ul>
        <p>Non chiediamo né raccogliamo altri dati personali (es. indirizzo, telefono, dati dei figli).</p>

        <h2 className="font-display text-2xl mt-8">4. Finalità del trattamento</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li><strong>Erogazione del servizio</strong>: identificazione dell'utente che pubblica esperienze e gestione del suo account personale.</li>
          <li><strong>Prevenzione abusi</strong>: controllo di esperienze multiple dalla stessa persona e moderazione di contenuti inappropriati.</li>
          <li><strong>Marketing diretto</strong> (solo con consenso esplicito separato): invio della newsletter editoriale di Per manina e comunicazioni della community. Il consenso è revocabile in qualsiasi momento dall'Area Personale.</li>
          <li><strong>Statistiche e miglioramento del sito</strong> (solo con consenso cookie): analisi aggregata del traffico tramite Google Analytics 4 con IP anonimizzato.</li>
          <li><strong>Pubblicità online</strong> (solo con consenso cookie di profilazione): mostrare annunci più rilevanti all'interno del sito. Vedi sezione 9.</li>
        </ul>

        <h2 className="font-display text-2xl mt-8">5. Base giuridica</h2>
        <p>Trattiamo i dati sulla base di:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li><strong>Esecuzione del contratto</strong> (art. 6.1.b GDPR) per la gestione dell'account registrato.</li>
          <li><strong>Consenso esplicito</strong> (art. 6.1.a GDPR) per: marketing diretto, cookie analitici, cookie di profilazione pubblicitaria. Ogni consenso è separato, non pre-flaggato e revocabile.</li>
          <li><strong>Legittimo interesse</strong> (art. 6.1.f GDPR) per cookie tecnici strettamente necessari al funzionamento del sito e per la sicurezza/prevenzione frodi.</li>
          <li><strong>Adempimento di obblighi legali</strong> (art. 6.1.c GDPR) per eventuali richieste di autorità competenti.</li>
        </ul>

        <h2 className="font-display text-2xl mt-8">6. Diritti dell'utente</h2>
        <p>In qualsiasi momento puoi esercitare i seguenti diritti previsti dal GDPR:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li><strong>Accesso</strong>: visualizzare i tuoi dati e le tue esperienze nell'Area Personale.</li>
          <li><strong>Rettifica</strong>: modificare o eliminare singole esperienze.</li>
          <li><strong>Revoca del consenso</strong>: dal toggle dedicato nell'Area Personale (marketing) o cancellando i cookie dal browser (cookie di profilazione).</li>
          <li><strong>Cancellazione (diritto all'oblio)</strong>: eliminare definitivamente il tuo account e tutte le esperienze associate tramite il pulsante "Elimina account".</li>
          <li><strong>Portabilità</strong>: ricevere i tuoi dati in formato elettronico leggibile (scrivici a <a href="mailto:info@permanina.it" className="text-[#C05C45] underline">info@permanina.it</a>).</li>
          <li><strong>Opposizione</strong>: opporti al trattamento per motivi legittimi.</li>
          <li><strong>Reclamo</strong>: puoi rivolgerti al Garante per la protezione dei dati personali (<a href="https://www.garanteprivacy.it" target="_blank" rel="noopener noreferrer" className="text-[#C05C45] underline">garanteprivacy.it</a>) qualora ritenessi violati i tuoi diritti.</li>
        </ul>

        <h2 className="font-display text-2xl mt-8">7. Conservazione dei dati</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li><strong>Dati account</strong>: fino alla cancellazione volontaria da parte dell'utente.</li>
          <li><strong>Contenuti pubblicati</strong> (recensioni): fino alla cancellazione dell'account o dell'esperienza stessa.</li>
          <li><strong>Email per newsletter</strong>: fino alla revoca del consenso marketing, dopodiché rimossa dalla mailing list entro 30 giorni.</li>
          <li><strong>Log tecnici di sicurezza</strong>: massimo 12 mesi.</li>
          <li><strong>Cookie</strong>: durata variabile secondo la Cookie Policy (vedi sezione 9).</li>
        </ul>

        <h2 className="font-display text-2xl mt-8">8. Trasferimenti e fornitori (data processors)</h2>
        <p>
          Per erogare il servizio ci avvaliamo di fornitori selezionati, ciascuno responsabile del trattamento ai sensi dell'art. 28 GDPR:
        </p>
        <ul className="list-disc pl-6 space-y-1">
          <li>
            <strong>Google LLC</strong> (USA, con garanzie di adeguatezza EU-US Data Privacy Framework): autenticazione utenti via Google OAuth, Google Analytics 4, Google AdSense (quando attivo), Google Tag Manager.{" "}
            <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-[#C05C45] underline">Privacy Policy di Google</a>.
          </li>
          <li>
            <strong>Sendinblue SAS (Brevo)</strong> (Francia): invio di email transazionali e newsletter.{" "}
            <a href="https://www.brevo.com/legal/privacypolicy/" target="_blank" rel="noopener noreferrer" className="text-[#C05C45] underline">Privacy Policy di Brevo</a>.
          </li>
          <li>
            <strong>Emergent Labs Inc.</strong> (USA, con garanzie SCC): infrastruttura cloud di hosting (server, database, storage).
          </li>
          <li>
            <strong>PostHog Inc.</strong> (USA): analytics prodotto per rilevare bug e migliorare l'esperienza utente (dati aggregati, nessun identificativo diretto).
          </li>
          <li>
            <strong>Fornitori pubblicitari IAB TCF 2.2</strong> (quando è attiva la pubblicità programmatica): vedi elenco completo nel <Link to="/info/cookie" className="text-[#C05C45] underline">Cookie Policy</Link> o direttamente nelle preferenze cookie del sito.
          </li>
        </ul>
        <p>
          Alcuni fornitori hanno sede fuori dall'UE: in tali casi applichiamo le garanzie previste dal Capo V del GDPR
          (decisioni di adeguatezza, Standard Contractual Clauses, EU-US Data Privacy Framework).
        </p>

        <h2 className="font-display text-2xl mt-8">9. Cookie e tecnologie simili</h2>
        <p>Per manina utilizza tre categorie di cookie:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>
            <strong>Cookie tecnici essenziali</strong> (sempre attivi, non richiedono consenso): sessione utente, preferenze
            tecniche, sicurezza anti-CSRF.
          </li>
          <li>
            <strong>Cookie analitici anonimi</strong> (solo con consenso): Google Analytics 4 con IP mascherato. Finalità:
            misurare traffico e comportamenti aggregati per migliorare contenuti e navigazione.
          </li>
          <li>
            <strong>Cookie di profilazione pubblicitaria</strong> (solo con consenso): Google AdSense, Google Ad Manager,
            Meta Pixel ed eventuali vendor pubblicitari aderenti al framework IAB TCF 2.2. Finalità: mostrare annunci
            personalizzati, misurare l'efficacia degli annunci, limitare la frequenza, prevenire frodi pubblicitarie.
            L'elenco completo dei vendor e le preferenze di consenso sono disponibili tramite il banner cookie (ri-apribile
            dal link "Preferenze cookie" in fondo a ogni pagina) e nel documento{" "}
            <Link to="/info/cookie" className="text-[#C05C45] underline">Cookie Policy</Link>.
          </li>
        </ul>
        <p>
          Puoi gestire o revocare in qualsiasi momento il consenso tramite il banner cookie
          o cancellando i cookie dal tuo browser.
        </p>

        <h2 className="font-display text-2xl mt-8">10. Pubblicità e contenuti sponsorizzati</h2>
        <p>
          Per sostenere i costi di gestione, Per manina può ospitare pubblicità in pagina. Rientrano in questa categoria:
        </p>
        <ul className="list-disc pl-6 space-y-1">
          <li>
            <strong>Pubblicità programmatica</strong> tramite Google AdSense, Google Ad Manager, Meta Audience Network e
            altri circuiti IAB TCF 2.2. Gli annunci sono erogati automaticamente in base al contesto della pagina e,
            quando l'utente lo acconsente, in base ai suoi interessi inferiti da cookie di profilazione. L'erogazione
            avviene solo dopo acquisizione del consenso tramite il banner cookie.
          </li>
          <li>
            <strong>Banner sponsorizzati diretti</strong> (vendita one-to-one a partner selezionati): ogni banner è
            etichettato con la dicitura <em>"Sponsorizzato"</em> come richiesto da AGCOM Delibera 132/19/CONS.
          </li>
          <li>
            <strong>Advertorial / contenuti sponsorizzati</strong> nel blog <em>"Papà Dito"</em>: articoli segnalati
            chiaramente come <em>"Contenuto sponsorizzato"</em>, prodotti in collaborazione con partner editoriali.
          </li>
          <li>
            <strong>Link di affiliazione</strong> (es. Amazon Associates) nelle schede prodotto: il clic può generare
            una commissione per Per manina senza alcun costo aggiuntivo per te.
          </li>
        </ul>
        <p>
          Non cediamo direttamente i tuoi dati personali a terzi senza il tuo consenso esplicito e specifico.
          I partner pubblicitari programmatici ricevono solo le informazioni consentite dal framework IAB TCF 2.2
          secondo le tue preferenze cookie.
        </p>

        <h2 className="font-display text-2xl mt-8">11. Minori</h2>
        <p>
          Il sito è rivolto a <strong>genitori ed educatori maggiorenni</strong>. Non raccogliamo intenzionalmente dati
          di minori. I contenuti pubblicati dagli utenti non devono contenere dati identificativi diretti dei bambini
          (nome, foto, data di nascita, scuola specifica frequentata associata a nome). Se individuiamo contenuti di
          questo tipo, li rimuoviamo d'ufficio.
        </p>

        <h2 className="font-display text-2xl mt-8">12. Sicurezza</h2>
        <p>
          Adottiamo misure tecniche e organizzative adeguate per proteggere i dati: cifratura HTTPS su tutte le pagine,
          hashing delle credenziali di sessione, controllo accessi role-based, backup regolari, log di sicurezza.
        </p>

        <h2 className="font-display text-2xl mt-8">13. Modifiche</h2>
        <p>
          Eventuali modifiche alla presente policy verranno comunicate aggiornando la data in alto. In caso
          di modifiche sostanziali agli scopi del trattamento, ti chiederemo nuovamente il consenso esplicito.
        </p>
      </section>
    </article>
  );
}
